<template>
	<search-group
  @search="findData"
  @clear="clearValue"
  :span="24"
  :inline="false"
  :btnOffset="21"
  >
		<Row class="mb16" :gutter="16">
			<Col span="4">
        <Select v-model="searchData.cityCode" placeholder="门店城市" @on-change="getMendianList(searchData.cityCode)">
          <Option value=''>请选择</Option>
          <Option v-for="(item,index) in mendianCity" :key="'s1'+index" :value="item.value">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="4">
        <Select v-model="searchData.projectFid" placeholder="门店">
          <Option value=''>请选择</Option>
          <Option v-for="(item,index) in mendianArr" :key="'s2'+index" :value="item.value">{{item.text}}</Option>
        </Select>
      </Col>
			<Col span="4">
        <!-- <Select
          v-model="searchData.roomFid"
          placeholder="房间号"
          filterable
          remote
          :remote-method="remoteMethod"
          :not-found-text="''"
        >
          <Option v-for="item in roomList" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select> -->
				<Input v-model="searchData.roomName" placeholder="房间号" :maxlength="50"></Input>
			</Col>

			<Col span="4">
        <Select v-model="searchData.householdRegistrationProvinceCode" placeholder="户籍省份" @on-change="getCity(searchData.householdRegistrationProvinceCode)">
          <Option value=''>请选择</Option>
          <Option v-for="(item,index) in provincesArr" :key="'s2'+index" :value="item.value">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="4">
        <Select v-model="searchData.householdRegistrationCityCode" placeholder="户籍城市">
          <Option value=''>请选择</Option>
          <Option v-for="(item,index) in registerCity" :key="'s3'+index" :value="item.value">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="4">
        <Select v-model="searchData.known" placeholder="是否为已知入住人" >
          <Option value=''>请选择</Option>
          <Option value='true'>是</Option>
          <Option value='false'>否</Option>
        </Select>
      </Col>

		</Row>
		<Row class="mb16" :gutter="16">
      <Col span="4">
        <Select v-model="searchData.returned" placeholder="是否进入自如寓居住" >
          <Option value=''>请选择</Option>
          <Option value='true'>是</Option>
          <Option value='false'>否</Option>
        </Select>
      </Col>
      <Col span="5">
        <DatePicker style="width:100%" type="datetime" placeholder="返回/预计返回自如寓日期" format="yyyy-MM-dd" v-model="searchData.returnDate"></DatePicker>
      </Col>
     <Col span="5">
        <Select v-model="searchData.backTransportationType" placeholder="返程交通方式" >
          <Option value=''>请选择</Option>
          <Option v-for="(item,index) in transportationArr" :key="'s2'+index" :value="item.value">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="5">
          <Select v-model="searchData.throughEpidemicArea" placeholder="春节期间是否途径疫情重点地区">
            <Option value=''>请选择</Option>
            <Option value='true'>是</Option>
            <Option value='false'>否</Option>
          </Select>
        </Col>
      <Col span="5">
        <Select v-model="searchData.throughEpidemicAreaCode" placeholder="途径情况" >
          <Option value=''>请选择</Option>
          <Option v-for="(item,index) in throughEpidemicAreaList" :key="'s2'+index" :value="item.value">{{item.text}}</Option>
        </Select>
      </Col>

		</Row>
    <Row class="mb16" :gutter="16">
      <Col span="5">
        <Select v-model="searchData.reachHighriskGroups" placeholder="1.15后是否接触过高危人群" >
          <Option value=''>请选择</Option>
          <Option value='true'>是</Option>
          <Option value='false'>否</Option>
        </Select>
      </Col>
      <Col span="5">
        <Select v-model="searchData.todayBodyTemperature" placeholder="过去24小时自测体温" >
          <Option value=''>请选择</Option>
          <Option v-for="(item,index) in temperatureList" :key="'s2'+index" :value="item.value">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="5">
        <Select v-model="searchData.suspectedSymptomsToday" placeholder="过去24小时是否有疑似症状" >
          <Option value=''>请选择</Option>
          <Option value='true'>是</Option>
          <Option value='false'>否</Option>
        </Select>
      </Col>
      <Col span="6">
        <Select v-model="searchData.reachHighriskGroupsToday" placeholder="过去24小时是否接触过高危人群" >
          <Option value=''>请选择</Option>
          <Option value='true'>是</Option>
          <Option value='false'>否</Option>
        </Select>
      </Col>

    </Row>
    <Row class="mb16" :gutter="16">
      <Col span="7">
        <Select v-model="searchData.neighbourSuspectedSymptoms" placeholder="过去24小时邻居或室友是否有疑似症状" >
          <Option value=''>请选择</Option>
          <Option value='true'>是</Option>
          <Option value='false'>否</Option>
        </Select>
      </Col>
      <Col span="4">
        <DatePicker style="width:100%" type="datetime" placeholder="填写调研日期" format="yyyy-MM-dd" v-model="searchData.surveyDate"></DatePicker>
      </Col>

      <Col span="4">
        <Select v-model="searchData.recordToday" placeholder="今日填写状态" >
          <Option value=''>请选择</Option>
          <Option value='true'>已填写</Option>
          <Option value='false'>未填写</Option>
        </Select>
      </Col>
      <Col span="4">
				<Input v-model="searchData.transportationNumber" placeholder="航班号/火车车次" :maxlength="60"></Input>
			</Col>
      <Col span="4">
				<Input v-model="searchData.searchText" placeholder="手机号/姓名" :maxlength="60"></Input>
			</Col>
    </Row>
	</search-group>
</template>

<script>
import SearchGroup from 'components/SearchGroup/index';
import { formatDateTime } from "@/utils/format";
import {getCities,mendianList} from 'api/customerhealth'
// import { fuzzyRoom, roomOwn} from 'api/workOrder'

export default {
	components:{
		SearchGroup,
  },
  props:{
    temperatureList:{
      type:Array,
      default(){
        return []
      }
    },
    provincesArr:{
      type:Array,
      default(){
        return []
      }
    },
    mendianCity:{
      type:Array,
      default(){
        return []
      }
    },
    transportationArr:{
      type:Array,
      default(){
        return []
      }
    },
    throughEpidemicAreaList:{
      type:Array,
      default(){
        return []
      }
    }

  },
	data(){
		return{
      searchData:{},
      regionList:[],
      registerCity:[],
      mendianArr:[],
      roomList: [],
      remoteLoading: false,
      cacheList:[],
		}
  },
  // computed:{

  // },
  created(){
    this.$emit('search',this.searchData)
  },
	methods:{
    getCity(parentCode){
			getCities({parentCode:parentCode})
			.then(res=>{
        this.registerCity = res.data;
			})
			.catch(err=>{
				console.log(err)
			})
    },
    getMendianList(cityCode){
      mendianList({projectCityCode:cityCode})
      .then(res=>{
        this.mendianArr = res.data;
      })
    },
    // remoteMethod(query) {
    //     if (query && this.searchData.projectFid) {
    //       let params = {
    //         projectid: this.searchData.projectFid,
    //         roomnumber: query
    //       }
    //       fuzzyRoom(params).then(res => {
    //           this.remoteLoading = false;
    //           this.roomList = res.data;
    //       })
    //     } else {
    //       this.roomList = [];
    //       this.searchData.roomFid = ''
    //     }
    //   },

		findData(){
      this.searchData.returnDate = formatDateTime(this.searchData.returnDate,false)
      this.searchData.surveyDate = formatDateTime(this.searchData.surveyDate,false)
      this.$emit('search',this.searchData)
    },

		clearValue(){
      this.searchData = {
        backTransportationType:'',
        cityCode:'',
        householdRegistrationCityCode:'',
        householdRegistrationProvinceCode:'',
        projectFid:'',
        reachHighriskGroups:'',
        reachHighriskGroupsToday:'',
        recordToday:'',
        returnDate:'',
        returned:'',
        roomName:'',
        searchText:'',
        surveyDate:'',
        suspectedSymptomsToday:'',
        throughEpidemicArea:'',
        transportationNumber:'',
        throughEpidemicAreaDesc:'',
      }
		}
	}
}
</script>

<style>

</style>
